import { render } from "./SignUpVerify.vue?vue&type=template&id=4a9fdefb&scoped=true"
import script from "./SignUpVerify.vue?vue&type=script&lang=js"
export * from "./SignUpVerify.vue?vue&type=script&lang=js"

import "./SignUpVerify.vue?vue&type=style&index=0&id=4a9fdefb&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9fdefb"]])

export default __exports__